export const statelessRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'error.404',
    meta: {
      title: 'Not Found',
      layout: 'blank',
    },
    beforeEnter: (to: any) => {
      if (to.path.includes('/install-module')) {
        return false;
      }
    },
    component: () => import('./404Page.vue'),
  },
];
